import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getPlatform } from '@/hooks';

const { Customer, UI } = Mobi2Go;

const LoyaltyEnticement = () => {
    const [loyalty, setLoyalty] = useState(null);
    const [isDataCandyEnabled, setIsDataCandyEnabled] = useState(false);
    const [chosenCard, setChosenCard] = useState('');
    const [isSpoonityEnabled, setIsSpoonityEnabled] = useState(false);
    const [isCustomerOptedIn, setIsCustomerOptedIn] = useState(false);
    const [isAccountVerified, setIsAccountVerified] = useState(false);
    const [isComoEnabled, setIsComoEnabled] = useState(false);

    const [t] = useTranslation('customer');

    const updateCustomer = () => {
        setLoyalty(Customer.getLoyalty('DataCandyLoyalty'));
        setIsSpoonityEnabled(Customer.getLoyalty('SpoonityLoyalty')?.program?.settings?.authentication_enabled);
        setIsAccountVerified(Customer.getLoyalty('SpoonityLoyalty')?.state?.is_profile_verified);
        setIsCustomerOptedIn(Customer.getLoyaltyOptIn());
        setIsComoEnabled(Customer.getLoyalty('ComoLoyalty')?.program?.enabled);
    }

    useEffect(() => {
        updateCustomer();

        Customer.bind({
            logIn: updateCustomer,
            updateLoyalty: updateCustomer,
        })

        return () => {
            Customer.unbind({
                logIn: updateCustomer,
                updateLoyalty: updateCustomer
        })}
    }, []);

    useEffect(() => {
        if (loyalty){
            setIsDataCandyEnabled(loyalty.program?.enabled);
            setChosenCard(loyalty.state?.chosen_card);
        }
    }, [loyalty]);

    const onPolicyClick = () => {
        UI.page.disableAnimation();
        UI.trigger('showPolicy', 'loyalty');
        UI.page.restoreAnimation();
    }

    const onButtonClick = () => {
        UI.page.disableAnimation();
        UI.trigger('showCustomerDetails');
        UI.page.restoreAnimation();
    }

    const displayOptInQuestion =
        (isDataCandyEnabled && !chosenCard) ||
        (isSpoonityEnabled && !isCustomerOptedIn) ||
        (isComoEnabled && !isCustomerOptedIn)
    ;

    const displayOptInButton = !isCustomerOptedIn && (isSpoonityEnabled || isComoEnabled);

    const displayVerifyButton = isSpoonityEnabled && isCustomerOptedIn && !isAccountVerified;

    const className = name => `m2g-customer-loyalty-enticement${name || ''}`;

    if (getPlatform() === 'web') {
        return (
            <>
                {displayOptInButton &&
                    <>
                        <div
                            className={className('__container')}
                        >
                            <p
                                className={className('__text')}
                            >
                                {t('loyalty_opt_in_question')}
                                <a
                                    className={className('__link')}
                                    onClick={() => UI.trigger('showPolicy', 'loyalty')}
                                >
                                    {t('loyalty_scheme_name')}
                                </a>
                            </p>
                        </div>

                        <button
                            className={className('__button m2g-button m2g-button--primary m2g-form-element--full-width')}
                            onClick={() => UI.trigger('showCustomerDetails')}
                        >
                            {t('loyalty:opt_in_button')}
                        </button>
                    </>
                }
            </>
        )
    } else {
        return (
            <>
                {displayOptInQuestion &&
                    <div
                        className={className('-container m2g-list-cell')}
                    >
                        <p
                            className={className('-text')}
                        >
                            {t('loyalty_opt_in_question')}
                            <a
                                className={className('-text-link m2g-touchable')}
                                onClick={onPolicyClick}
                            >
                                {t('loyalty_scheme_name')}
                            </a>
                        </p>
                    </div>
                }

                {displayOptInButton &&
                    <button
                        className="m2g-button m2g-order-section-button"
                        onClick={onButtonClick}
                    >
                        {t('loyalty:opt_in_button')}
                    </button>
                }

                {displayVerifyButton &&
                    <button
                        className="m2g-button m2g-order-section-button"
                        onClick={() => UI.trigger('showCustomerProfile')}
                    >
                        {t('loyalty:verify_account_button')}
                    </button>
                }
            </>
        )
    }
}

export default LoyaltyEnticement;
